// // // src/components/ProtectedRoute.jsx
// // import { Navigate } from "react-router-dom";
// // import { useAuth } from "../hooks/useAuth";

// // export default function ProtectedRoute({ children }) {
// //   const { user, loading } = useAuth();

// //   if (loading) {
// //     return (
// //       <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
// //         <div style={{ textAlign: "center" }}>
// //           <div style={{ width: 36, height: 36, borderRadius: "50%", border: "3px solid #DEE2E6", borderTopColor: "#185FA5", animation: "spin 0.7s linear infinite", margin: "0 auto 12px" }} />
// //           <p style={{ fontSize: 14, color: "#868E96" }}>Loading...</p>
// //         </div>
// //       </div>
// //     );
// //   }

// //   return user ? children : <Navigate to="/login" replace />;
// // }

// src/components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ width: 36, height: 36, borderRadius: "50%", border: "3px solid #DEE2E6", borderTopColor: "#185FA5", animation: "spin 0.7s linear infinite", margin: "0 auto 12px" }} />
          <p style={{ fontSize: 14, color: "#868E96" }}>Loading...</p>
        </div>
      </div>
    );
  }

  // Not logged in
  if (!user) return <Navigate to="/login" replace />;

  // Email not verified — but allow if already on verify page
  if (!user.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  return children;
}